import React from 'react';

const EducationIcon = () => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512"  xmlSpace="preserve">
<g transform="translate(1 1)">
	<g>
		<path d="M506.733,217.667L259.267,81.987c-2.56-1.707-5.973-1.707-8.533,0L3.267,217.667C0.707,219.373-1,221.933-1,225.347
			c0,2.56,1.707,5.973,5.12,6.827l29.013,14.107v79.943l-23.04,51.017c-4.267,9.387-3.413,20.48,2.56,29.867
			c5.973,9.387,15.36,14.507,26.453,14.507h5.973c10.24,0,19.627-4.267,25.6-13.653s6.827-20.48,2.56-29.867l-23.04-51.84v-71.676
			l42.667,20.745v66.931c0,21.333,12.8,41.813,33.28,52.053l17.067,8.533C178.2,420.76,216.6,429.293,255,429.293
			c38.4,0,76.8-8.533,112.64-25.6l17.067-8.533c20.48-10.24,33.28-30.72,33.28-52.053v-67.346l87.893-42.734
			c3.413-1.707,5.12-4.267,5.12-7.68S509.293,219.373,506.733,217.667z M57.027,397.72c-2.56,4.267-6.827,6.827-11.947,6.827h-5.973
			c-5.12,0-10.24-2.56-12.8-6.827s-2.56-9.387-0.853-13.653l16.213-35.84l16.213,35.84C60.44,388.333,59.587,393.453,57.027,397.72z
			 M400.92,284.227v58.88c0,15.36-9.387,29.867-23.893,36.693l-17.067,8.533c-65.707,32.427-143.36,32.427-209.067,0l-17.067-8.533
			c-14.507-7.68-23.893-22.187-23.893-36.693v-58.88l141.653,68.267c0.853,0.853,2.56,0.853,3.413,0.853s2.56,0,3.413,0
			l103.314-50.232L400.92,284.227z M255,335.427L105.667,262.04c-0.943-0.314-2.002-0.51-3.09-0.55l-30.644-14.865l142.259-17.118
			c5.294,17.524,21.353,29.973,40.809,29.973c23.893,0,42.667-18.773,42.667-42.667c0-23.893-18.773-42.667-42.667-42.667
			c-22.407,0-40.311,16.511-42.452,38.272L43.287,232.73l-16.98-8.237L255,98.2l228.693,126.293L255,335.427z M263.533,215.107
			c-0.853-5.12-5.12-8.533-9.387-7.68l-23.966,2.876c2.763-11.187,12.575-19.089,24.819-19.089c14.507,0,25.6,11.093,25.6,25.6
			c0,14.507-11.093,25.6-25.6,25.6c-10.688,0-19.517-6.026-23.428-14.998l24.281-2.922
			C260.973,223.64,264.387,219.373,263.533,215.107z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>

  );
};

export default EducationIcon;
